import axios from '@/http/axios'

export function getProductRequirements (loading) {
  return axios({
    url: 'v1/app/{tenant}/requirements/products',
    loading,
    method: 'get'
  })
}

export function getInvoiceRequirements (loading) {
  return axios({
    url: 'v1/app/{tenant}/requirements/invoices',
    loading,
    method: 'get'
  })
}

export function getPrintRequirement (loading) {
  return axios({
    url: 'v1/app/{tenant}/requirements/print',
    loading,
    method: 'get'
  })
}

export function getStoreroomReceiptRequirement (loading) {
  return axios({
    url: 'v1/app/{tenant}/requirements/storeroom-receipt',
    loading,
    method: 'get'
  })
}

export function getTreasuryRequirement (loading) {
  return axios({
    url: 'v1/app/{tenant}/requirements/treasuries',
    loading,
    method: 'get'
  })
}

export function getLanguages (loading) {
  return axios({
    url: 'v1/core/languages',
    loading,
    method: 'get'
  })
}

export function getLanguageFile (file, loading) {
  return axios({
    url: `v1/core/assets/${file}?t=${Math.random()}`,
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    },
    loading,
    method: 'get'
  })
}

export function getCurrencies (loading) {
  return axios({
    url: 'v1/core/currencies',
    loading,
    method: 'get'
  })
}

export function getTimezones (loading) {
  return axios({
    url: 'v1/core/timezones',
    loading,
    method: 'get'
  })
}
